import gql from 'graphql-tag';

export const PROVISION_SIGN_INTEGRATION = gql`
  mutation provisionSignIntegration($input: ProvisionSignIntegrationInput!) {
    provisionSignIntegration(input: $input) {
      errors
      success
    }
  }
`;
